import type { Tag } from "./model";

// The user gives a SIMPLE rating per dimension (1..5). The scarce, relative
// signal is recovered internally by normalising each viewer's ratings within a
// dimension to shares that sum to 1. There is no visible budget.
export const RATING_MIN = 1;
export const RATING_MAX = 5;

export function isValidRating(rating: number): boolean {
  return Number.isInteger(rating) && rating >= RATING_MIN && rating <= RATING_MAX;
}

// Normalisation denominator: the sum of ratings across a dimension's tags.
export function totalRating(tags: readonly Tag[]): number {
  return tags.reduce((sum, t) => sum + t.rating, 0);
}

// A rating's relative share within its dimension. This is the only number the
// lens exposes; per-dimension shares sum to 1, so the relative-share property
// holds without any budget surfaced to the user.
export function share(rating: number, total: number): number {
  return total === 0 ? 0 : rating / total;
}
